import { UseBackHandler } from './types';
export const useBackHandler: UseBackHandler = () => undefined;
